module.exports = __webpack_public_path__ + "static/img/icon_map.a9c23d3.png";